import Vue from 'vue'
import axios from 'axios'
import { Message, Notification } from '@jd/element-ui'
import { isNull } from '@/utils'
import Cookies from 'js-cookie'
import getTranslation from '@/i18n/getTranslation'
import _array from 'lodash/array'
// import {LINK} from ''
const service = axios.create({
  timeout: 20000,
  withCredentials: true
})
// loading 组
let ARR_LOADING = []
let IS_LOADING = false
let LOADING_INSTANCE = null

let ARR_LOADING_TIME = []
service.interceptors.request.use(config => {
  if (config.isLoading) {
    ARR_LOADING.push(config.url)
    if (!IS_LOADING) {
      IS_LOADING = true
      let loadingConfig = {}
      if (config.target) {
        loadingConfig.target = config.target
      }
      LOADING_INSTANCE = Vue.$loading(loadingConfig)
    }
  }
  if (config.computeResponseTime) {
    let apiData = {}
    apiData[`${config.method}${config.url}`] = new Date()
    ARR_LOADING_TIME.push(apiData)
  }
  Object.assign(config.headers, {
    'x-lang': Cookies.get('jdcloud_sitelang') || 'cn'
  })
  if (config.isCsrf && Cookies.get('csrfToken')) {
    Object.assign(config.headers, {
      'x-csrf-token': Cookies.get('csrfToken')
    })
  }
  return config
})
service.interceptors.response.use(
  response => {
    let {
      data: { code, success, message, data, result, error },
      config
    } = response
    if (config.isLoading) {
      let index = ARR_LOADING.indexOf(config.url)
      ARR_LOADING.splice(index, 1)
      if (ARR_LOADING.length === 0) {
        if (LOADING_INSTANCE) {
          LOADING_INSTANCE.close()
        }
        LOADING_INSTANCE = null
        IS_LOADING = false
      }
    }
    if (config.computeResponseTime) {
      let key = `${config.method}${config.url}`
      let arr = ARR_LOADING_TIME.filter(val => val[key])
      if (arr.length > 0) {       
        _array.remove(ARR_LOADING_TIME, arr[0])
      }
    }
    // 如果不是code 返回值
    if (isNull(code) && isNull(success)) {
      return response.data
    }
    if (code !== 0 || success === false) {
      // 是否自动提示消息
      if (config.isOutMsg) {
        Message({
          type: 'error',
          message:
            message || getTranslation('出错啦，请确认网络是否正常，稍后再试')
        })
      }
      return Promise.reject({ code, error, message, result, data }) // eslint-disable-line
    } else {
      return response.data
    }
  },
  error => {
    const { config, response } = error
    ARR_LOADING = []
    if (LOADING_INSTANCE) {
      LOADING_INSTANCE.close()
      LOADING_INSTANCE = null
    }
    IS_LOADING = false
    if (config.computeResponseTime) {
      let key = `${config.method}${config.url}`
      let arr = ARR_LOADING_TIME.filter(val => val[key])
      if (arr.length > 0) {
        _array.remove(ARR_LOADING_TIME, arr[0])
      }
    }
    if (!response) {
      const msg = error.message.includes('timeout')
        ? getTranslation('接口请求超时')
        : error
      Message({
        type: 'error',
        message: msg || getTranslation('出错啦，请确认网络是否正常，稍后再试')
      })
      return Promise.reject(error)
    }
    const { status, data } = response
    if (status === 401) {
      if (data && data.isRole) {
        let redirectUrl = Cookies.get('r_url')
        window.location.href =
          redirectUrl + `?returnUrl=${encodeURIComponent(window.location.href)}`
      } else {
        window.location.href =
          derivativeConfig.login + encodeURIComponent(window.location.href)
      }
      return Promise.reject({ status: 401 })
    }
    if (status === 402) {
      window.location.href =
        derivativeConfig.active + encodeURIComponent(window.location.href)
      return Promise.reject({ status: 402 })
    }
    if (status === 403) {
      if (data.message.indexOf('[gw]' !== -1)) {
        Notification({
          type: 'error',
          title: '您没有权限执行此操作，请联系管理员为您添加权限。',
          message: data.message,
          duration: 10000
        })
      } else {
        window.location.href = derivativeConfig.permission
      }
      return Promise.reject({ status: 403 })
    }
    if (config.isOutMsg) {
      Message({
        type: 'error',
        message: data ? data.message : '出错啦，请确认网络是否正常，稍后再试'
      })
      return Promise.reject(error)
    }
  }
)
export default service
